module.exports = __webpack_public_path__ + "img/zm.927f193f.svg";